<template>
  <div>
    <loader-component v-if="is_loading" />
    <div v-else>
      <div class="alert alert-danger d-flex" v-if="!is_connected">
        <span class="mr-auto">
          <i class="bi bi-x-circle"></i> Token tidak valid! Silahkan hubungkan
          kembali.
        </span>
      </div>
      <button
        v-if="is_connected"
        @click="logoutFacebok"
        class="btn btn-block btn-info btn-lg"
        type="button"
        style="background: #4267b2"
      >
        <i class="bi bi-facebook"></i>
        <span>Terhubung dengan ID: {{ facebook_user_id }}</span>
      </button>
      <button
        v-else
        @click="loginWithFacebook"
        aria-label=""
        class="btn btn-block btn-info btn-lg"
        type="button"
        style="background: #4267b2"
      >
        <i class="bi bi-facebook"></i>
        <span>Hubungkan Facebook</span>
      </button>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import "firebase/auth";
import loader from "@/views/components/loader.vue";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
import swal from "sweetalert";

export default {
  name: "FacebookLogin",
  components: {
    "loader-component": loader,
  },
  data() {
    return {
      is_connected: false,
      is_loading: true,
      facebook_user_id: null,
      facebook_creds: null,
      loading_key: 0,
      id_project: this.$store.getters.user.id_project,
      id_user: this.$store.getters.user.user_id.$oid,
      param: null,
    };
  },
  created() {
    this.getCredentials();
    this.loadFacebookSDK(document, "script", "facebook-jssdk");
    this.initFacebook();
  },
  methods: {
    getCredentials() {
      this.is_loading = true;
      let url =
        process.env.VUE_APP_API_URL +
        "get-user-creds-medsos/" +
        this.id_project;
      this.$http
        .get(url)
        .then((res) => {
          if (res.status == 200) {
            this.facebook_creds = res.data.user_creds.creds;
            this.facebook_user_id = res.data.user_creds.id_user;
            if (
              "is_valid" in res.data.user_creds &&
              res.data.user_creds.is_valid == false
            ) {
              this.is_connected = false;
            } else {
              this.is_connected = true;
            }
          } else {
            this.is_connected = false;
          }
        })
        .catch(() => {
          this.is_connected = false;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    loginWithFacebook() {
      let refs = this;
      window.FB.login(
        function (response) {
          if (response.authResponse) {
            let data = {
              source: "facebook",
              id_user: response.authResponse.userID,
              id_project: refs.id_project,
              creds: response.authResponse,
            };
            refs.saveLoginData(data);
          }
        },
        {
          config_id: process.env.VUE_APP_CONFIG_ID,
          response_type: "code",
        }
      );
      return false;
    },
    initFacebook() {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.VUE_APP_ID_FB,
          cookie: true,
          xfbml: true,
          version: "v17.0",
        });
      };
    },
    loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    saveLoginData: function (data) {
      let api = process.env.VUE_APP_API_URL + "user-creds-medsos";
      this.$http
        .post(api, data)
        .then((response) => {
          if (response.status == 200) {
            this.getCredentials();
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil dihubungkan.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          } else {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Terjadi Kesalahan.',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          }
        })
        .catch((err) => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> ' +
                err.response.data.status,
              position: "top",
              timeout: 10000,
              type: "danger",
            })
            .show();
        });
    },
    logoutFacebok() {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan keluar dari akun facebook.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        if (yess) {
          let url =
            process.env.VUE_APP_API_URL +
            "delete-user-creds-medsos/" +
            self.facebook_user_id;
          self.$http
            .delete(url)
            .then(() => {
              self.getCredentials();
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun facebook berhasil dikeluarkan.',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            })
            .catch(() => {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat keluar dari akun facebook',
                  position: "top",
                  timeout: 10000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
  },
};
</script>
<style>
.button {
  color: white;
  min-width: 150px;
  background-color: #000000a1;
  height: 2.5rem;
  border-radius: 2rem;
  font-weight: 400;
  font-size: 0.8rem;
}
</style>
